/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2021] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

// import _ from 'lodash';
import Backbone from 'backbone';
import { View } from 'backbone.marionette';
import Radio from 'backbone.radio';

import Session from '../../../../Session';
import ExternalHeaderView from '../ExternalHeaderView';
import InternalHeaderView from '../InternalHeaderView';
// import BasicHeaderView from '../BasicHeaderView';

import tmplHeaderView from './HeaderView.hbs';

const HeaderView = View.extend({
  template: tmplHeaderView,

  ui: {
    navbar: '.navbar',
    headerWrapper: '.header-wrapper',
    headerContainer: '.header-container',
    internalAppSelectHeader: '.int-app-select-header',
    externalHeader: '.ext-header',
    internalHeader: '.int-header',
    logout: '.logout'
  },

  regions: {
    wrapper: '@ui.headerWrapper',
    externalHeader: '@ui.externalHeader',
    internalHeader: '@ui.internalHeader',
    internalAppSelectHeader: '@ui.internalAppSelectHeader'
  },

  events: {
    'click @ui.logout': 'onLogout'
  },

  onRender() {
    Radio.channel('header').on('login:external', () => this.onRadioLoginExternal());
    Radio.channel('header').on('login:internal', (currentRoute) => this.onRadioLoginInternal(currentRoute));
    Radio.channel('header').on('show:external', () => this.onRadioShowExternal());
    Radio.channel('header').on('show:internal', (currentRoute) => this.onRadioShowInternal(currentRoute));
    // Radio.channel('header').on('show:int-app-select', () => this.onRadioShowInternalAppSelect());
    Radio.channel('header').on('hide:header', () => this.onRadioHideHeader());
  },

  onLogout() {
    Radio.channel('global').trigger('logout:finish');
  },

  onRadioLoginExternal() {
    this.showChildView(
      'externalHeader',
      new ExternalHeaderView({
        model: new Backbone.Model({
          user: Session.user,
          customerID: Session.user.id
        })
      })
    );
  },

  onRadioLoginInternal(currentRoute) {
    // Render both the app selection header and the internal header, which
    // both start out hidden, and then make sure only the correct one is
    // actually made visible.
    // this.showChildView(
    //   'internalAppSelectHeader',
    //   new BasicHeaderView({
    //     model: new Backbone.Model({
    //       user: Session.user,
    //       brandText: 'Internal Portal',
    //     }),
    //   })
    // );

    const brand = this.getInternalBrandConfigByRoute(currentRoute);
    this.internalHeader = new InternalHeaderView({
      model: new Backbone.Model({
        user: Session.user,
        brand
      })
    });
    this.showChildView('internalHeader', this.internalHeader);
  },

  onRadioShowExternal() {
    if (this.ui.externalHeader.hasClass('collapse')) {
      this.hideHeader();
      this.ui.externalHeader.removeClass('collapse');
    }
  },

  onRadioShowInternal(currentRoute) {
    if (this.internalHeader) {
      if (this.internalHeader.setBrand) {
        const brandConfig = this.getInternalBrandConfigByRoute(currentRoute);
        this.internalHeader.setBrand(brandConfig);
      }
    }
    if (this.ui.internalHeader.hasClass('collapse')) {
      this.hideHeader();
      this.ui.internalHeader.removeClass('collapse');
    }
  },

  // onRadioShowInternalAppSelect() {
  //   if (this.ui.internalAppSelectHeader.hasClass('collapse')) {
  //     this.hideHeader();
  //     this.ui.internalAppSelectHeader.removeClass('collapse');
  //   }
  // },

  onRadioHideHeader() {
    this.hideHeader();
  },

  hideHeader() {
    this.ui.headerContainer.each(function () {
      $(this).addClass('collapse');
    });
  },

  getInternalBrandConfigByRoute(route) {
    // Determine what the brand text of the header bar should be based on the
    // current route which is bassed in from the Context Loader.
    return { text: 'EMS', link: '#dashboard' };
  }
});

export default HeaderView;
